import {PAdbContext} from "../PA.Core/PAdbContext";
import {AuditService} from "../PA.Core/Security/AuditService";
import {PlanTypeBO} from "./PlanTypeBO";
import {auditFieldFK, AuditUtils, IAuditField} from "../PA.Core/Basic/AuditUtils";
import {AuditLogType} from "../PA.Core/PA.Core.IF.Audit";
import {WB_ProductGroupRow} from "../PA.Core/PAdbSchemaRows";
import * as _ from "lodash";
import {esWB_Event_Type, esWB_Fund_Type} from "../PA.Core/PAdbSchema";

export class PlanTypeBOAudit {


    static async PlanTypeAuditBO(PlanTypeBO: PlanTypeBO): Promise<AuditService> {
        const self = PlanTypeBO
        const auditService = new AuditService(self.dbContext)
        auditService.setReference("PlanMType", self.drWB_PlanType.cif.WB_PLANM_ID)

        // @ts-ignore
        self.deleteKeys = self.deleteKeys || {}
        // @ts-ignore
        let deleteKeys: any = self.deleteKeys

        const tpmPlanParams: IAuditField [] = [
            {fieldName: "PLANM_ID", realName: "ID",}, //create
            {fieldName: "PLANM_NAME", realName: "Name",}, //create
            {fieldName: "VALID_FROM", realName: "Valid From",},
            {fieldName: "VALID_THRU", realName: "Valid Through"},
            {fieldName: "WB_BUSINESSUNIT_ID", realName: "Business Unit"},
            {fieldName: "QUANTITY_UOM", realName: "Quantity UOM"},
            {fieldName: "CURRENCY", realName: "Currency"},
            {fieldName: "WB_CUSTH_ID", realName: "Customer Hierarchy"},
            {fieldName: "WB_CUSTH_ID_SUBPLANNING", realName: "Sub Planning Hierarchy", bAllMsg: true}, //create
            {fieldName: "SUBPLANNING_LEVEL_ID", realName: "Sub Planning Level", bAllMsg: true}, //create
            {fieldName: "PRECREATE_PGS_IND", realName: "Pre Create Product Groups",},
            {fieldName: "EVENTCALENDAR_SHOW_IND", realName: "Show Event Calendar"},
            {fieldName: "SHIPPERTAB_SHOW_IND", realName: "Show Shipper Tab"},
            {fieldName: "WB_PRDH_ID", realName: "Product Hierarchy"},
            {fieldName: "PRDGRP_LEVEL_ID", realName: "Product Group Level"},
            {fieldName: "WB_PERIODM_ID", realName: "Period Type"},
            {fieldName: "WB_PERIODM_ID_MONTH", realName: "Period Type Month", bAllMsg: true}, //create
            {fieldName: "WB_PERIODH_ID", realName: "Period Hierarchy", bAllMsg: true}, //create
            {fieldName: "WB_PERIODH_ID_MONTH", realName: "Period Hierarchy Month",},
            {fieldName: "METRICVIEWS", realName: "SVF Metric Views"},
            {fieldName: "METRICVIEW_DEFAULT", realName: "Default SVF Metric View"},
            {fieldName: "SVFMETRICVIEWS", realName: "SVF Metric Views"},
            {fieldName: "SVFMETRICVIEW_DEFAULT", realName: "Default SVF Metric View"},
            {fieldName: "BVPMETRICVIEWS", realName: "SVF Metric Views"},
            {fieldName: "BVPMETRICVIEW_DEFAULT", realName: "Default SVF Metric View"},
            {fieldName: "METRICVIEWSPERIODSUMMARY", realName: "By Period Metric View"},
            {fieldName: "METRICVIEWPERIODSUMMARY_DEFAULT", realName: "Default By Period Metric View"},
            {fieldName: "STANDARDCALCULATORCLASS", realName: "Standard Calculator Class"},
            {fieldName: "PLANCALCULATORCLASS", realName: "Plan Calculator Class", bAllMsg: true}, //create
            {fieldName: "CONSUMPTION_PLANNING_MODE", realName: "Consumption Planning Mode", bAllMsg: true}, //create
            {fieldName: "SHIPMENT_PLANNING_MODE", realName: "Shipment Planning Mode",},
            {fieldName: "WB_TAG_ID_USAGE", realName: "Tag Usage"},
            {fieldName: "BASELINEPY_SOURCES", realName: "Baseline PY Source"},
            {fieldName: "BASELINEPY_SOURCE_DEFAULT", realName: "Default Baseline PY Source"},
            {fieldName: "BASELINEALT_SOURCES", realName: "Baseline ALT Source"},
            {fieldName: "BASELINEALT_SOURCE_DEFAULT", realName: "Default Baseline ALT Source"},
            {fieldName: "RETAIL_CALENDAR_START_DEFAULT", realName: "Retail Calendar Start Default"},
            {fieldName: "DISPLAY_HANDLING_METHOD_ID", realName: "Display Volume Handling"},
            {fieldName: "PERIOD_ALLOC_METHOD_ID", realName: "Cross Week Allocation Policy"},

        ]

        // TPM Event Type Rows
        const tpmEventTypeParams: IAuditField [] = [
            {
                fieldName: "WB_EVTTYPE_ID",
                realName: "Event Type",
                bAllMsg: true,
                fkMapper: esWB_Event_Type,
                fkMapperNameField: "TYPE_NAME",
                fkMapperIdField:"TYPE_ID"
            },
            {fieldName: "REL_SORT", realName: "Sort Order",},
            {fieldName: "EFFECTIVE_START_DT", realName: "Effective Start Date",},
            {fieldName: "EFFECTIVE_END_DT", realName: "Effective End Date"},
        ]

        // TPM Fund Type Rows
        const tpmFundTypeParams: IAuditField [] = [
            {
                fieldName: "WB_FUNDTYPE_ID",
                realName: "Fund Type",
                bAllMsg: true,
                fkMapper: esWB_Fund_Type,
                fkMapperNameField: "FUNDTYPE_NAME",
                fkMapperIdField:"FUNDTYPE_ID"
            },
            {fieldName: "REL_SORT", realName: "Sort",},
            {fieldName: "PRD_CNDM_ID_STD", realName: "Std Funding Rate",},
            {fieldName: "PRD_CNDM_ID_ADDL", realName: "Addl Funding Rate",},
            {fieldName: "EFFECTIVE_START_DT", realName: "Effective Start Date",},
            {fieldName: "EFFECTIVE_END_DT", realName: "Effective End Date",},
        ]


        // Execute Audit Logging
        await AuditUtils.logRecord(auditService, self.WB_PlanType, tpmPlanParams, {
            objectName: 'PlanMType',
            deletedKeys: deleteKeys
        })

        // TPM Event Type Rows
        for (let aTPMEventRow of self.drWB_PlanType.WB_PlanTypeEventTypeRows) {
            await AuditUtils.logRecord(auditService, aTPMEventRow, tpmEventTypeParams, {
                objectName: 'PlanMType Event Type',
                deletedKeys: deleteKeys
            })
        }

        // TPM Fund Type Rows
        for (let aTPMFundRow of self.drWB_PlanType.WB_PlanTypeFundTypeRows) {
            // let bLogInsertDeltes = aTPMPrdRow.cif.ROW_TYPE === 'Display'
            await AuditUtils.logRecord(auditService, aTPMFundRow, tpmFundTypeParams, {
                objectName: 'PlanMType Fund Type',
                deletedKeys: deleteKeys
            })
        }


        return auditService
    }


}
